import {
  FETCH_DELIVERY_DETAIL_REQUEST,
  FETCH_DELIVERY_DETAIL_SUCCESS,
  FETCH_DELIVERY_DETAIL_FAILURE,
  CLEAR_DELIVERY_DETAIL,
} from '../actions/deliveryDetail';

const defaultState = {
  loading: false,
  loaded: false,
  id: null,
  item: null
};

export default function deliveryDetail(state = defaultState, action) {
  switch (action.type) {
    case CLEAR_DELIVERY_DETAIL:
      return {
        ...state,
        defaultState
      };
    case FETCH_DELIVERY_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        id: action.payload.id
      };
    case FETCH_DELIVERY_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        item: action.payload.item,
        lastUpdated: action.payload.receivedAt,
      };
    case FETCH_DELIVERY_DETAIL_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}
